import React, {useEffect, useState} from 'react';
import {Navigate, Route, Routes, useLocation, useNavigate,} from 'react-router-dom';
import NotFoundScreen from "../screens/not-found/notFoundScreen";
import AppLayout from "../layouts/app-layout/appLayout";
import AuthLayout from "../layouts/auth-layout/authLayout";
import {
    ACCESSIONING_LIST,
    BARCODES_LIST_ROUTE,
    BULK_ORDER_LIST_ROUTE,
    BULK_ORDER_VIEW_ROUTE,
    COMING_SOON_ROUTE,
    DASHBOARD,
    DESIGN_SYSTEM_ROUTE,
    FACILITY_ADD_ROUTE,
    FACILITY_DETAILS_LOCATIONS_ROUTE,
    FACILITY_DETAILS_ROUTE,
    FACILITY_LIST_ROUTE,
    LAB_CREATE_ROUTE,
    LAB_DETAILS_ROUTE,
    LAB_LIST_ROUTE,
    LOCATION_ADD_ROUTE,
    LOCATION_DETAILS_ROUTE,
    LOCATION_DETAILS_TEST_ORDER_ROUTE,
    LOCATION_LIST_ROUTE,
    LOGIN_ROUTE,
    NOT_FOUND_ROUTE,
    PATIENT_ADD_ROUTE,
    PATIENT_DETAILS_ROUTE,
    PATIENT_LIST_ROUTE,
    QR_CODE_LIST_ROUTE,
    RESTRICTED_ROUTE,
    RESULT_LIST_ROUTE,
    RESULT_PREVIEW_ROUTE,
    SAMPLES_LIST_ROUTE,
    SEND_OUT_SESSION_DETAILS_ROUTE,
    SEND_OUT_SESSION_LIST_ROUTE,
    STATE_REPORTING_LIST_ROUTE,
    STATE_REPORTING_VIEW_ROUTE,
    SYSTEM_SETTINGS_ROUTE,
    TEST_ORDER_CREATE_ROUTE,
    TEST_ORDER_DETAILS_ROUTE,
    TEST_ORDER_LIST_ROUTE,
    TEST_CREATE_ROUTE,
    TEST_DETAILS_ROUTE,
    TEST_LIST_ROUTE,
    TEST_ROUTE,
    TEST_SAMPLE_ACTIVITY_LOGS_ROUTE,
    ACCESS_LEVEL_LIST_ROUTE,
    ACCESS_LEVEL_ROLE_DETAILS_ROUTE,
    OCR_ROUTE,
    INVENTORY_LIST_ROUTE,
    INVENTORY_ADD_ROUTE,
    INVENTORY_DETAILS_ROUTE,
    ACCESS_LEVEL_ADD_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    PASSWORD_RESET_SUCCESSFUL,
    SET_NEW_PASSWORD,
    CHECK_YOUR_MAIL,
    BIOMARKERS_LIST_ROUTE,
    BIOMARKER_ADD_ROUTE,
    BIOMARKER_DETAILS_ROUTE,
    TEST_PANEL_LIST_ROUTE,
    USER_LIST_ROUTE,
    USER_ADD_ROUTE,
    USER_DETAILS_ROUTE,
    LAB_OS_ROUTE,
    QUALITY_CONTROL_ROUTE,
    QUALITY_ASSURANCE_ROUTE,
    HR_EMPLOYEE_DOCUMENTS_ROUTE,
    INVENTORY_MANAGEMENT_ROUTE,
    SOP_ROUTE,
    INSTRUMENT_ROUTE,
    FORMS_ROUTE,
    LABOS_DEPARTMENTS_ROUTE,
    LABOS_EQUIPMENT_ROUTE,
    LABOS_STORAGE_ROUTE,
    PLATES_ROUTE,
    LABOS_CALCULATIONS_ROUTE,
    LABOS_REPORTS_ROUTE, BULK_PATIENT_LIST_ROUTE, BULK_PATIENT_VIEW_ROUTE,
    SUPPORT_CENTER_ROUTE,
    SIGNATURE_ROUTE, PRIVACY_POLICY,
} from "../constants/RoutesConfig";
import TestScreen from "../screens/test/testScreen";
import DesignSystemScreen from "../screens/design-system/DesignSystemScreen";
import LoginScreen from "../screens/auth/login/loginScreen";
import ComingSoonScreen from "../screens/coming-soon/comingSoonScreen";
import SamplesListScreen from "../screens/samples-list/samplesListScreen";
import AccessioningScreen from "../screens/accessioning/accessioningScreen";
import ResultListScreen from '../screens/result/result-list/resultListScreen';
import LocationListScreen from '../screens/location/LocationListScreen';
import FacilityListScreen from '../screens/facility/FacilityListScreen';
import PatientListScreen from '../screens/patient/PatientListScreen';
import LabListScreen from "../screens/labs/labListScreen";
import ResultPreviewScreen from "../screens/result/result-preview/resultPreviewScreen";
import TestOrderCreationScreen from '../screens/test-order/test-order-add/TestOrderCreateScreen';
import PatientAddScreen from "../screens/patient/patient-add/patientAddScreen";
import DashboardScreen from "../screens/dashboard/dashboardScreen";
import SendoutSessionListScreen from "../screens/sendouts/sendout-session-list/SendoutSessionListScreen";
import SendoutSessionDetailsScreen from "../screens/sendouts/sendout-session-details/SendoutSessionDetailsScreen";
import TestOrderListScreen from "../screens/test-order/test-order-list/TestOrderListScreen";
import PatientDetailsScreen from "../screens/patient/patient-details/patientDetailsScreen";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../store/reducers";
import {CommonService} from "../shared/services";
import RestrictedRouteComponent from "../shared/components/restricted-route/RestrictedRouteComponent";
import TestOrderDetailsScreen from "../screens/test-order/test-order-details/testOrderDetailsScreen";
import QrCodeListScreen from "../screens/qr-code/QrCodeScreen";
import TestCreateScreen from "../screens/test-and-panel/test-add/TestCreateScreen";
import TestDetailsScreen from "../screens/test-and-panel/test-details/testDetailsScreen";
import LabAddComponent from "../screens/labs/lab-add/LabAddComponent";
import LabDetailsScreen from "../screens/labs/lab-details/LabDetailsScreen";
import FacilityCreateScreenComponent from "../screens/facility/facility-add/facilityCreateScreen";
import FacilityDetailsLocationsScreen
    from "../screens/facility/facility-details-locations/facilityDetailsLocationsScreen";
import FacilityDetailsScreen from "../screens/facility/facility-details/facilityDetailsScreen";
import LocationAddScreen from "../screens/location/location-add/locationAddScreen";
import LocationDetailsTestOrdersComponent
    from "../screens/location/location-details-test-orders/locationDetailsTestOrdersComponent";
import LocationDetailsScreen from "../screens/location/location-details/locationDetailsScreen";
import BulkTestOrderListScreen from "../screens/bulk-test-order/bulkTestOrderListScreen";
import BulkTestOrderViewComponent from "../screens/bulk-test-order/bulk-test-order-view/BulkTestOrderViewComponent";
import StateReportingScreen from "../screens/state-reporting/StateReportingScreen";
import StateReportingDetailsComponent
    from "../screens/state-reporting/state-reporting-details/StateReportingDetailsComponent";
import {setCurrentRoute} from "../store/actions/stateManagement.action";
import BarcodesListScreen from "../screens/barcodes/BarcodesListScreen";
import SystemSettingsScreen from "../screens/system-settings/SystemSettingsScreen";
import TestSampleActivityLogsComponent
    from "../screens/test-order/test-sample-activity-logs/TestSampleActivityLogsComponent";
import AccessLevelListComponent from "../screens/access-level/access-level-list/AccessLevelListComponent";
import AccessLevelDetailsComponent from "../screens/access-level/access-level-details/AccessLevelDetailsComponent";
import {setSystemLocked} from "../store/actions/account.action";
import OcrScreenComponent from "../screens/ocr/OcrScreenComponent";
import InventoryScreenComponent from "../screens/inventory/InventoryScreenComponent";
import InventoryAddComponent from "../screens/inventory/inventory-add/InventoryAddComponent";
import InventoryDetailsComponent from "../screens/inventory/inventory-details/InventoryDetailsComponent";
import AccessRoleAddComponent from "../screens/access-level/access-role-add/AccessRoleAddComponent";
import ForgotPasswordComponent from "../screens/auth/Forgot-password/ForgotPasswordComponent";
import SetNewPasswordComponent from "../screens/auth/set-new-password/SetNewPasswordComponent";
import CheckMailComponent from "../screens/auth/check-mail/CheckMailComponent";
import SuccessfullResetPasswordComponent
    from "../screens/auth/successfull-reset-password/SuccessfullResetPasswordComponent";
import BiomarkersComponent from "../screens/biomarkers/BiomarkersComponent";
import BiomarkersAddComponent from "../screens/biomarkers/biomarkers-add/BiomarkersAddComponent";
import BiomarkerDetailsComponent from "../screens/biomarkers/biomarker-details/BiomarkerDetailsComponent";
import TestPanelComponent from "../screens/test-and-panel/test-panel/TestPanelComponent";
import TestListScreen from "../screens/test-and-panel/TestScreen";
import UserManagementComponent from "../screens/user-management/UserManagementComponent";
import UserAddComponent from "../screens/user-management/user-add/UserAddComponent";
import UserDetailsComponent from "../screens/user-management/user-details/UserDetailsComponent";
import LabOsComponent from "../screens/lab-os/LabOsComponent";
import QualityControlComponent from "../screens/lab-os/quality-control/QualityControlComponent";
import QualityAssuranceComponent from "../screens/lab-os/quality-assurance/QualityAssuranceComponent";
import HrEmployeeDocumentsComponent from "../screens/lab-os/hr-employee-documents/HrEmployeeDocumentsComponent";
import InventoryManagementComponent from "../screens/lab-os/inventory-management/InventoryManagementComponent";
import SopValidationComponent from "../screens/lab-os/sop-validation/SopValidationComponent";
import InstrumentComponent from "../screens/lab-os/instrument/InstrumentComponent";
import FormsComponent from "../screens/lab-os/forms/FormsComponent";
import DepartmentsComponent from "../screens/lab-os/departments/DepartmentsComponent";
import EquipmentComponent from "../screens/lab-os/equipment/EquipmentComponent";
import StorageComponent from "../screens/lab-os/storage/StorageComponent";
import PlatesComponent from "../screens/lab-os/plates/PlatesComponent";
import SampleProcessingComponent from "../screens/lab-os/sample-processing/SampleProcessingComponent";
import CalculationsComponent from "../screens/lab-os/calculations/CalculationsComponent";
import SelectDropdownComponent from "../shared/components/core/select-dropdown/SelectDropdownComponent";
import {setSelectedLab} from "../store/actions/selectedLab.action";
import ButtonComponent from "../shared/components/core/button/ButtonComponent";
import DialogComponent from "../shared/components/dialog/dialogComponent";
import ReportsComponent from "../screens/lab-os/reports/ReportsComponent";
import BulkPatientUploadScreen from "../screens/bulk-patient-upload/BulkPatientUploadScreen";
import BulkPatientViewComponent from "../screens/bulk-patient-upload/bulk-patient-view/BulkPatientViewComponent";
import NoInternetComponent from "../shared/components/no-internet/NoInternetComponent";
import SupportCenterScreenComponent from "../screens/support-center/SupportCenterScreenComponent";
import SignatureScreenComponent from '../screens/signature-screen/SignatureScreenComponent';
import PrivacyPolicyScreenComponent from '../shared/components/layout/privacy-policy/PrivacyPolicyScreenComponent';

const ProtectedRoute = (props: React.PropsWithChildren<any>) => {

    const {module, feature, children} = props;
    const navigate = useNavigate();
    const {token} = useSelector((state: IRootReducerState) => state.account);
    const signature = useSelector((state: IRootReducerState) => state.account.userSignature);
    const location = useLocation();
    const dispatch = useDispatch();

    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    useEffect(() => {
        if (!token) {
            dispatch(setSystemLocked(false, undefined));
            navigate('/login?returnUrl=' + encodeURIComponent(location.pathname + location.search));
        }
    }, [token, navigate, location, dispatch]);
    useEffect(() => {
        // We are doing this to prevent an infinite loop. If the user needs to register a signature and the current path is the signature route, we don't need to redirect again and again.
        if ((signature?.isSignatureRequired && !signature.signature) && location.pathname !== SIGNATURE_ROUTE) {
            navigate(SIGNATURE_ROUTE + `?returnUrl=${encodeURIComponent(location.pathname + location.search)}`);
        }
    }, [signature?.isSignatureRequired, signature?.signature, navigate, location])

    const userAccess = currentUser?.userAccessModules;

    let canAccess: boolean = false;
    if (!feature) {
        if (module === 'dashboard') {
            canAccess = true;
        } else {
            canAccess = userAccess && Object.keys(userAccess).includes(module);
        }
    } else {
        let featureAccess: any = [];
        userAccess && Object.keys(userAccess).map((key) => {
            if (key === module) {
                featureAccess = userAccess[key];
            }
            return key;
        });
        canAccess = featureAccess.map((featureObject: any) => featureObject?.feature).includes(feature);
        console.log(featureAccess)
    }
    // override canAccess if the feature is a mutation feature
    if (feature && CommonService.isMutationFeature(feature)) {
        canAccess = false;
    }
    // override canAccess if the module is specific module to hide
    if (module && CommonService.isSpecificModuleToHide(module)) {
        canAccess = false;
    }
    useEffect(() => {
        if (!canAccess) {
            navigate(RESTRICTED_ROUTE);
        }
    }, [canAccess, location, navigate]);
    return children;
}

export interface NavigatorProps {

}

const Navigator = (props: NavigatorProps) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const {token} = useSelector((state: IRootReducerState) => state.account);

    const [route, setRoute] = useState<string>('');
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const {selectedLab} = useSelector((state: IRootReducerState) => state.selectedLab);
    const {labListLite} = useSelector((state: IRootReducerState) => state.staticData);
    const [labSelectionModalOpen, setLabSelectionModalOpen] = React.useState<boolean>(false);
    const {currentNavParams} = useSelector((state: IRootReducerState) => state.header);
    const navigate = useNavigate();
    const roleCode = currentUser?.roleObj?.code;
    const [selectedLabId, setSelectedLabId] = useState<string | undefined>(undefined);

    useEffect(() => {
        const sub = CommonService._communications.URLQueryParamsDataSubject
            .subscribe((data) => {
                if (data) {
                    const route = data.split(window.location.origin)[1];
                    setRoute(route);
                    dispatch(setCurrentRoute(route, false));
                }
            });
        return () => {
            sub.unsubscribe();
        }
    }, [route, dispatch]);

    useEffect(() => {
        dispatch(setCurrentRoute(location.pathname, true));
    }, [dispatch, location]);

    useEffect(() => {
        const sub = CommonService._communications.LabSelectionSubject.subscribe((data) => {
            if (data) {
                setLabSelectionModalOpen(true);
            }
        })
        return () => {
            sub.unsubscribe();
        }
    }, []);
    useEffect(() => {
        if (!token) {
            setLabSelectionModalOpen(false)
        }
    }, [token]);

    return (
        <NoInternetComponent>
            <Routes>
                <Route element={<AppLayout/>}>
                    {token &&
                        <Route index element={roleCode === 'billing' ?
                            <ProtectedRoute module={'TestOrder'}>
                                <TestOrderListScreen/>
                            </ProtectedRoute> :
                            <ProtectedRoute module={'dashboard'}>
                                <DashboardScreen/>
                            </ProtectedRoute>}/>}
                    <Route
                        path={DASHBOARD}
                        element={
                            <ProtectedRoute module={'dashboard'}>
                                <DashboardScreen/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ACCESSIONING_LIST}
                        element={
                            <ProtectedRoute module={'Accession'}>
                                <AccessioningScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={TEST_ORDER_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'TestOrder'}>
                                <TestOrderListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={TEST_ORDER_CREATE_ROUTE}
                        element={
                            <ProtectedRoute module={'TestOrder'} feature={"testOrderAdd"}>
                                <TestOrderCreationScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={TEST_ORDER_DETAILS_ROUTE + '/:testOrderID'}
                        element={
                            <ProtectedRoute module={'TestOrder'} feature={"testOrderList"}>
                                <TestOrderDetailsScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={TEST_SAMPLE_ACTIVITY_LOGS_ROUTE + '/:testOrderId/:testSampleID'}
                        element={
                            <ProtectedRoute module={'TestOrder'} feature={"sampleActivityLog"}>
                                <TestSampleActivityLogsComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={SAMPLES_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'TestOrderSample'}>
                                <SamplesListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={RESULT_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'Result'}>
                                <ResultListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={RESULT_PREVIEW_ROUTE + '/:sessionID'}
                        element={
                            <ProtectedRoute module={'Result'} feature={"resultList"}>
                                <ResultPreviewScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={LOCATION_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'Location'}>
                                <LocationListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={LOCATION_ADD_ROUTE}
                        element={
                            <ProtectedRoute module={'Location'} feature={"locationAdd"}>
                                <LocationAddScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={LOCATION_DETAILS_ROUTE + '/:locationId'}
                        element={
                            <ProtectedRoute module={'Location'} feature={"locationList"}>
                                <LocationDetailsScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={FACILITY_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'Facility'}>
                                <FacilityListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={FACILITY_ADD_ROUTE}
                        element={
                            <ProtectedRoute module={'Facility'} feature={"facilityAdd"}>
                                <FacilityCreateScreenComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={FACILITY_DETAILS_LOCATIONS_ROUTE + '/:facilityId'}
                        element={
                            <ProtectedRoute module={'Facility'} feature={"facilityList"}>
                                <FacilityDetailsLocationsScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={FACILITY_DETAILS_ROUTE + '/:facilityId'}
                        element={
                            <ProtectedRoute module={'Facility'} feature={"facilityList"}>
                                <FacilityDetailsScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={PATIENT_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'Patient'}>
                                <PatientListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={LAB_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'Lab'}>
                                <LabListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={QR_CODE_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'QrCodes'}>
                                <QrCodeListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={PATIENT_ADD_ROUTE}
                        element={
                            <ProtectedRoute module={'Patient'} feature={"patientAdd"}>
                                <PatientAddScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={BULK_PATIENT_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'Patient'} feature={"patientAdd"}>
                                <BulkPatientUploadScreen/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={BULK_PATIENT_VIEW_ROUTE + '/:bulkPatientID'}
                        element={
                            <ProtectedRoute module={'Patient'} feature={"patientAdd"}>
                                <BulkPatientViewComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={SEND_OUT_SESSION_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'SendOuts'}>
                                <SendoutSessionListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={SEND_OUT_SESSION_DETAILS_ROUTE + '/:sessionID'}
                        element={
                            <ProtectedRoute module={'SendOuts'} feature={"sendoutsList"}>
                                <SendoutSessionDetailsScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={PATIENT_DETAILS_ROUTE + '/:patientID'}
                        element={
                            <ProtectedRoute module={'Patient'} feature={"patientList"}>
                                <PatientDetailsScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={TEST_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={'Test'} feature={'testList'}>
                                <TestListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={TEST_CREATE_ROUTE}
                        element={
                            <ProtectedRoute module={'Test'} feature={"addTest"}>
                                <TestCreateScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={TEST_DETAILS_ROUTE + '/:testID'}
                        element={
                            <ProtectedRoute module={'Test'} feature={"testList"}>
                                <TestDetailsScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={LAB_CREATE_ROUTE + '/:labRole'}
                        element={
                            <ProtectedRoute module={'Lab'} feature={"labAdd"}>
                                <LabAddComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={LOCATION_DETAILS_TEST_ORDER_ROUTE + '/:locationId'}
                        element={
                            <ProtectedRoute module={'Location'} feature={"locationList"}>
                                <LocationDetailsTestOrdersComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={LAB_DETAILS_ROUTE + '/:labID/:labRole'}
                        element={
                            <ProtectedRoute module={'Lab'} feature={"labList"}>
                                <LabDetailsScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={BULK_ORDER_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={"TestOrder"} feature={"testOrderBulkList"}>
                                <BulkTestOrderListScreen/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={BULK_ORDER_VIEW_ROUTE + '/:bulkOrderID'}
                        element={
                            <ProtectedRoute module={"TestOrder"} feature={"testOrderBulkList"}>
                                <BulkTestOrderViewComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={STATE_REPORTING_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={"StateReporting"}>
                                <StateReportingScreen/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={STATE_REPORTING_VIEW_ROUTE + '/:sessionID'}
                        element={
                            <ProtectedRoute module={"StateReporting"} feature={"stateReportingList"}>
                                <StateReportingDetailsComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={BARCODES_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={"Barcode"}>
                                <BarcodesListScreen/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={SYSTEM_SETTINGS_ROUTE}
                        element={
                            <ProtectedRoute module={"SystemSettings"}>
                                <SystemSettingsScreen/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ACCESS_LEVEL_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={"AccessControl"}>
                                <AccessLevelListComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ACCESS_LEVEL_ROLE_DETAILS_ROUTE + '/:roleId'}
                        element={
                            <ProtectedRoute module={"AccessControl"} feature={"accessControlList"}>
                                <AccessLevelDetailsComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ACCESS_LEVEL_ADD_ROUTE}
                        element={
                            <ProtectedRoute module={"AccessControl"} feature={"accessControlAdd"}>
                                <AccessRoleAddComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={INVENTORY_LIST_ROUTE}
                        element={
                            // <ProtectedRoute module={"Inventory"} feature={"InventoryList"}>
                            <InventoryScreenComponent/>
                            // </ProtectedRoute>
                        }
                    />
                    <Route
                        path={INVENTORY_ADD_ROUTE}
                        element={
                            // <ProtectedRoute module={"Inventory"} feature={"InventoryAdd"}>
                            <InventoryAddComponent/>
                            // </ProtectedRoute>
                        }
                    />
                    <Route
                        path={INVENTORY_DETAILS_ROUTE + '/:productId'}
                        element={
                            // <ProtectedRoute module={"Inventory"} feature={"InventoryList"}>
                            <InventoryDetailsComponent/>
                            // </ProtectedRoute>
                        }
                    />

                    <Route
                        path={BIOMARKERS_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={"Biomarker"}>
                                <BiomarkersComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={BIOMARKER_ADD_ROUTE}
                        element={
                            <ProtectedRoute module={"Biomarker"} feature={'addBiomarker'}>
                                <BiomarkersAddComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={BIOMARKER_DETAILS_ROUTE + '/:biomarkerId'}
                        element={
                            <ProtectedRoute module={"Biomarker"} feature={'biomarkerList'}>
                                <BiomarkerDetailsComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={TEST_PANEL_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={"Test"} feature={'testPanelList'}>
                                <TestPanelComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={USER_LIST_ROUTE}
                        element={
                            <ProtectedRoute module={"User"}>
                                <UserManagementComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={USER_ADD_ROUTE}
                        element={
                            <ProtectedRoute module={"User"} feature={'addUser'}>
                                <UserAddComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={USER_DETAILS_ROUTE + '/:userID'}
                        element={
                            <ProtectedRoute module={"User"} feature={'userList'}>
                                <UserDetailsComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route path={SUPPORT_CENTER_ROUTE} element={
                        <ProtectedRoute module={"dashboard"}>
                            <SupportCenterScreenComponent/>
                        </ProtectedRoute>
                    }/>
                    <Route
                        path={LAB_OS_ROUTE}
                        element={
                            <LabOsComponent/>
                        }
                    />
                    <Route
                        path={LAB_OS_ROUTE + "/sample-processing"}
                        element={
                            <ProtectedRoute module={"SampleProcessing"} feature={"SampleProcessingview"}>
                                <SampleProcessingComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={QUALITY_CONTROL_ROUTE}
                        element={
                            <ProtectedRoute module={"QualityControl"} feature={"QualityControlDashboardview"}>
                                <QualityControlComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={QUALITY_ASSURANCE_ROUTE}
                        element={
                            <ProtectedRoute module={"QualityAssurance"} feature={"QualityAssuranceview"}>
                                <QualityAssuranceComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={HR_EMPLOYEE_DOCUMENTS_ROUTE}
                        element={
                            <ProtectedRoute module={"HR&EmployeeDocuments"} feature={"HR&EmployeeDocumentsview"}>
                                <HrEmployeeDocumentsComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={INVENTORY_MANAGEMENT_ROUTE}
                        element={
                            <ProtectedRoute module={"InventoryManagement"} feature={"InventoryManagementview"}>
                                <InventoryManagementComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={INSTRUMENT_ROUTE}
                        element={
                            <ProtectedRoute module={"Instruments"} feature={"Instrumentsview"}>
                                <InstrumentComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={LABOS_DEPARTMENTS_ROUTE}
                        element={
                            <DepartmentsComponent/>
                        }
                    />

                    <Route
                        path={LABOS_EQUIPMENT_ROUTE}
                        element={
                            <EquipmentComponent/>
                        }
                    />

                    <Route
                        path={LABOS_STORAGE_ROUTE}
                        element={
                            <StorageComponent/>
                        }
                    />


                    <Route
                        path={SOP_ROUTE}
                        element={
                            <ProtectedRoute module={"SOP&Validation"} feature={"SOP&Validationview"}>
                                <SopValidationComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={FORMS_ROUTE}
                        element={
                            <ProtectedRoute module={"Forms"} feature={"Formsview"}>
                                <FormsComponent/>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={PLATES_ROUTE}
                        element={
                            <PlatesComponent/>
                        }
                    />

                    <Route
                        path={LABOS_CALCULATIONS_ROUTE}
                        element={
                            <CalculationsComponent/>
                        }
                    />

                    <Route
                        path={LABOS_REPORTS_ROUTE}
                        element={
                            <ProtectedRoute module={"Reports"} feature={"Reportsview"}>
                                <ReportsComponent/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={OCR_ROUTE}
                        element={
                            <OcrScreenComponent/>
                        }
                    />


                    <Route path={COMING_SOON_ROUTE} element={<ComingSoonScreen/>}/>
                </Route>
                <Route element={<AuthLayout/>}>
                    <Route index element={<LoginScreen/>}/>
                    <Route path={LOGIN_ROUTE} element={<LoginScreen/>}/>
                    <Route path={FORGOT_PASSWORD_ROUTE} element={<ForgotPasswordComponent/>}/>
                    <Route path={SET_NEW_PASSWORD + '/:otp'} element={<SetNewPasswordComponent/>}/>
                    <Route path={CHECK_YOUR_MAIL + '/:emailId'} element={<CheckMailComponent/>}/>
                    <Route path={PASSWORD_RESET_SUCCESSFUL} element={<SuccessfullResetPasswordComponent/>}/>
                </Route>
                <Route path={SIGNATURE_ROUTE} element={<ProtectedRoute module='dashboard'>
                    <SignatureScreenComponent/>
                </ProtectedRoute>}/>
                <Route path={PRIVACY_POLICY} element={<ProtectedRoute module='dashboard'>
                    <PrivacyPolicyScreenComponent/>
                </ProtectedRoute>}/>
                <Route path={TEST_ROUTE} element={<TestScreen/>}/>
                <Route path={DESIGN_SYSTEM_ROUTE} element={<DesignSystemScreen/>}/>
                <Route path={NOT_FOUND_ROUTE} element={<NotFoundScreen/>}/>
                <Route path={RESTRICTED_ROUTE} element={<RestrictedRouteComponent/>}/>
                <Route path="*" element={<Navigate to={NOT_FOUND_ROUTE}/>}/>
            </Routes>
            <DialogComponent open={labSelectionModalOpen} onClose={() => setLabSelectionModalOpen(false)}
                             title={'Select Lab'}>
                <div>
                    <div className={'lab-selection-wrapper pdd-top-10'}>
                        <SelectDropdownComponent name={'select-dropdown'} label={'Select Lab'}
                                                 options={labListLite}
                                                 value={labListLite.find((lab: any) => lab.id === selectedLab)}
                                                 size={'small'}
                                                 getOptionLabel={(option) => option.name}
                                                 onUpdate={(selectedOption: any) => {
                                                     setSelectedLabId(selectedOption?.id);
                                                     dispatch(setSelectedLab(selectedOption?.id));
                                                 }
                                                 }
                        />
                    </div>
                    <div className={'select-lab-dialog-action-wrapper'}>
                        <ButtonComponent
                            variant={'outlined'}
                            color={'primary'}
                            handleClick={() => {
                                setLabSelectionModalOpen(false)
                                navigate(currentNavParams?.backNavigationRoute || CommonService._routeConfig.Dashboard())
                            }}
                        >
                            Cancel
                        </ButtonComponent>
                        <ButtonComponent
                            variant={'contained'}
                            color={'primary'}
                            handleClick={() => setLabSelectionModalOpen(false)}
                            disabled={!selectedLabId}
                        >
                            Proceed
                        </ButtonComponent>
                    </div>
                </div>
            </DialogComponent>
        </NoInternetComponent>
    );

};

export default Navigator;



